import { useFeatureFlagEnabled } from '@/lib/posthog/hooks/useFeatureFlagEnabled';
import { isDesktopBrowser } from '@/modules/auth/isDesktopBrowser';

/**
 * Whether to offer LinkedIn sign-in: behind the `linkedinSso` flag, and only
 * in a desktop browser. On phones and tablets, and inside apps' built-in
 * browsers, LinkedIn's sign-in didn't work reliably, so those get Google and
 * Slack only.
 */
export const useLinkedInSsoEnabled = () => {
  const isFlagEnabled = useFeatureFlagEnabled('linkedinSso');

  return (
    isFlagEnabled &&
    isDesktopBrowser(navigator.userAgent, navigator.maxTouchPoints)
  );
};
